import React, { useState, useEffect, useContext } from "react";
import { UserContext, Utils } from "../../common";
import { Modal } from "react-bootstrap";
import VideoPlayer from "./VideoPlayer";

const HelpVideos = () => {
  const [hvs, setHvs] = useState(false);
  const { getHelpVideos, showHowToModal, setShowHowToModal } = useContext(UserContext);
  const [showModule, setShowModule] = useState(false);

  useEffect(() => {
    if (hvs === false) {
      getHelpVideos()
        .then((mods) => setHvs(Array.isArray(mods) ? mods : []))
        .catch(() => setHvs([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- load help list once on mount
  }, []);

  const renderHelpPlayer = () => {
    return (
      <Modal show={true} size="lg" centered onHide={() => setShowModule(false)} style={{ zIndex: 1065 }}>
        <Modal.Header closeButton style={{ background: "var(--dt-navy)", color: "#fff", borderBottom: "none" }}>
          <Modal.Title style={{ fontSize: "16px", fontWeight: 700 }}>
            🎬 Tutorial: {showModule.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3" style={{ background: "#F8FAFC" }}>
          {showModule.details && (
            <div className="p-3 mb-3 bg-white rounded border small text-muted">
              {showModule.details}
            </div>
          )}
          <VideoPlayer src={showModule.videourl} title={showModule.title} />
        </Modal.Body>
      </Modal>
    );
  };

  if (!showHowToModal && !showModule) return null;

  return (
    <>
      {showHowToModal && (
        <Modal
          show={true}
          centered
          onHide={() => setShowHowToModal(false)}
          contentClassName="border-0 shadow-lg overflow-hidden"
          style={{ zIndex: 1055 }}
        >
          {/* Header matching user attached design */}
          <div className="p-4 d-flex align-items-start justify-content-between" style={{ background: "linear-gradient(145deg, #181059 0%, #0d0838 100%)", color: "#fff" }}>
            <div>
              <h4 className="fw-bold m-0" style={{ fontSize: "19px", letterSpacing: "-0.01em" }}>
                Let's Get You Started
              </h4>
              <p className="m-0 mt-1" style={{ fontSize: "13px", color: "rgba(255,255,255,0.75)" }}>
                Know How To Use Denttrack Modules
              </p>
            </div>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() => setShowHowToModal(false)}
              aria-label="Close"
            />
          </div>

          <Modal.Body className="p-3" style={{ background: "#F8FAFC", maxHeight: "65vh", overflowY: "auto" }}>
            {(!hvs || hvs.length === 0) ? (
              <div className="text-center py-4 text-muted small">
                No video guides currently available for your branch.
              </div>
            ) : (
              <div className="d-flex flex-column gap-1">
                {hvs.map((hv, idx) => (
                  <button
                    key={idx}
                    type="button"
                    className="w-100 text-start d-flex align-items-center gap-3 p-3 rounded bg-white border mb-1 btn-reset"
                    style={{ fontSize: "14px", fontWeight: 600, color: "#1E293B", transition: "all .12s", boxShadow: "0 1px 2px rgba(0,0,0,0.03)" }}
                    onClick={() => {
                      setShowModule(hv);
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "#007AFF";
                      e.currentTarget.style.background = "#EFF6FF";
                      e.currentTarget.style.transform = "translateX(3px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "#E2E8F0";
                      e.currentTarget.style.background = "#FFFFFF";
                      e.currentTarget.style.transform = "none";
                    }}
                  >
                    <span
                      style={{
                        width: 30,
                        height: 30,
                        borderRadius: "8px",
                        background: "#181059",
                        color: "#FFFFFF",
                        display: "grid",
                        placeItems: "center",
                        flexShrink: 0
                      }}
                    >
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                    </span>
                    <span className="flex-grow-1 text-truncate">{hv.title}</span>
                    <span className="text-muted small">Watch ↗</span>
                  </button>
                ))}
              </div>
            )}
          </Modal.Body>
        </Modal>
      )}

      {showModule !== false && renderHelpPlayer()}
    </>
  );
};

export default HelpVideos;
